<template>
<div class="bg">
  <Nav-bar :has_back="true" :has_right="false" title="我的钱包"></Nav-bar>
  <div class="top-margin"></div>
  <div class="container m-t-10">
    <img src="@/images/my_wallet_balance_background.png" class="bg" />
    <div class="info-view">
      <div class="margin">
        <span class="t-f14-cff">账户余额</span>
        <span class="t-f30-cff m-t-5">{{ balance }}</span>
      </div>
    </div>
    <div class="b-v">
      <span class="b-i t-f16-cff font-bold block-btn-l" @click="toRecharge"
        >充值</span
      >
      <span class="b-i t-f16-cff font-bold block-btn-r" @click="toWithdrawal"
        >提现</span
      >
    </div>
  </div>
  <div class="column list-container">
    <div class="list-item" @click="toWithdrawalRecord">
      <img src="@/images/refund_record.png" class="item-icon" />
      <div class="column m-l-10">
        <span class="t-f16-c28">提现记录</span>
        <span class="t-f12-c99">查看您所有提现记录</span>
      </div>
      <img src="@/images/arrows.png" class="right-i" />
    </div>
    <div class="list-item" @click="toPayment">
      <img src="@/images/payment.png" class="item-icon" />
      <div class="column m-l-10">
        <span class="t-f16-c28">支付明细</span>
        <span class="t-f12-c99">查看您近半年的充值支付明细</span>
      </div>
      <img src="@/images/arrows.png" class="right-i" />
    </div>
  </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import { useRouter } from "vue-router";
import request from "@/api/request";
import { ref } from "vue";
let router;
let balance = ref("");
export default {
  components: {
    NavBar,
  },
  setup() {
    router = useRouter();
    //查询金额
    getUserInfoBalance();

    return { toRecharge, toPayment, toWithdrawalRecord, toWithdrawal, balance };
  },
};
function toWithdrawalRecord() {
  router.push("/user/withdrawal_record");
}
function toRecharge() {
  router.push("/user/recharge");
}
function getUserInfoBalance() {
  request.getUserInfo().then((res) => {
    balance.value = res.data.balance;
  });
}
function toPayment() {
  router.push("/user/payment");
}
function toWithdrawal() {
  router.push("/user/Withdrawal");
}
</script>

<style  lang="scss" scoped>
.bg{
  background: #fff !important;
}
.right-i {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 15px;
  height: 18px;
}
.list-container {
  margin: 20px;
}
.t-f12-c99 {
  color: #999;
  font-size: 12px;
}
.t-f16-c28 {
  font-size: 16px;
  color: #282828;
}
.item-icon {
  width: 35px;
  height: 35px;
}
.list-item {
  position: relative;
  display: flex;
  flex-direction: row;
  padding: 20px 0px;
  border-bottom: 1px solid #f1f2f3;
}
.column {
  display: flex;
  flex-direction: column;
}
.withdrawal {
  position: absolute;
  right: 30px;
  top: 20px;
  font-size: 14px;
  text-decoration: underline;
  color: #fff;
}
.container {
  position: relative;
  height: 185px;
  margin: 20px;
}
.bg {
  width: 100%;
  height: 100%;
}
.info-view {
  position: absolute;
  text-align: center;
  left: 50%;
  transform: translateX(-50%);
  top: 30px;
}
.margin {
  margin: 0px 30px;
  flex-direction: column;
  display: flex;
}
.b-v {
  display: flex;
  position: absolute;
  bottom: 20px;
  left: 20px;
  right: 20px;
}
.b-i {
  flex: 1;
  line-height: 50px;
  text-align: center;
  border-radius: 10px;
}
.block-btn-l {
  background: rgba(0, 130, 255, 0.3);
}
.block-btn-r {
  background: rgba(255, 255, 255, 0.3);
  margin-left: 15px;
}
</style>